<template>
    <div>
        <appEditor></appEditor>
    </div>
</template>
<script>

    import Editor from './components/Editor.vue';

    export default {
        components : {
            appEditor : Editor
        },
        created () {
            this.$store.dispatch( 'initLabels' );
            this.$store.dispatch( 'initStocks' );
            this.$store.getters.labels.forEach( function( element ) {
                store.dispatch( 'SETBACKGROUNDS', {record : element} );
            } );
            this.$store.dispatch( 'initStrings' );
            this.$store.dispatch( 'initDefault' );
            //this.$store.dispatch('')


        },
        mounted () {

           setTimeout((function(_this){
               return function(  ) {
                   _this.$store.getters.labels.forEach( function( element ) {
                       store.dispatch( 'setMasterText', {labelId : element.id} );/*
                if ( typeof(element.print_options) != "undefined" ) {
                    var print_options = element.print_options;
                    $jQuery.each( print_options, function( index, option ) {
                        const activeOption = option.options.find( option => option.isActive == 1 )
                        if ( activeOption ) {
                            var option = $jQuery( "[name='" + activeOption.code + "']" );
                            var parent = $jQuery( option ).parent();
                            parent.find( 'option' ).attr( 'selected', false );
                        }
                    } )

                }*/
                   } );
               }
           })(this),400)


            $jQuery( '.design-label-btn' ).on( 'click', ((function( _this ) {
                return function() {
                    setTimeout( (function( _this ) {
                        return function() {
                            _this.$store.getters.labels.forEach( function( element ) {
                                store.dispatch( 'setMasterText', {labelId : element.id} );
                               // PrintOptions.changeData();
                            } );
                        }
                    })( _this ), 200 )
                }
            })( this )) )
            if(edit_type == "order" || window.historyurl =="#redirect"){
                 $jQuery('.design-label-btn').trigger('click');
              //  PrintOptions.changeData();
            }

        }
    }
</script>
<style>
  .product.media,
  .product-reviews-summary,
  .product.attribute.overview,
  .product-info-price-wrapper,
  product.attribute.additional-info {
      display : none
  }

  #canvasArea {
      padding-top : 50px;
  }

  .product-images {
  }

  .product-single {
      transform : translateZ(0);
  }

  .page-wrapper {
      overflow : visible !important;
  }
    </style>



// WEBPACK FOOTER //
// src/App.vue